$(document).ready(function () {
  setTimeout(function () {
    $(
      ".product-info__variants-wrapper-custom-Size input[value='No'],.product-info__variants-wrapper-custom-Size input[value='NO']"
    ).click();
  }, 1000);

  if ($("body .product-info__variants-wrapper-custom-Size").length > 0) {
    $(".custom_size-wrapper").show();
  } else {
    $(".custom_size-wrapper").hide();
    $(".product-info__variants-wrapper-custom-Size").show();
  }
});

// 显示弹窗
function show_custom_size_pop(obj, type) {
  if (obj.classList.contains("active")) {
    obj.classList.remove("active");
    remove_data();
  } else {
    console.log(
      $(
        `.content-wrapper:eq(${
          type - 1
        }),.exit-pop-custom-size-content .change-wrapper .change:eq(${
          type - 1
        })`
      ),
      type
    );
    document
      .querySelector(".exit-pop-custom-size-wrapper")
      .classList.add("active");
    $(
      `.exit-pop-custom-size-content .content-wrapper-${type},.exit-pop-custom-size-content .change-wrapper .change:eq(${
        type - 1
      })`
    )
      .addClass("active")
      .siblings()
      .removeClass("active");
  }
}
// 关闭弹窗
function hide_custom_size_pop() {
  document
    .querySelector(".exit-pop-custom-size-wrapper")
    .classList.remove("active");
}
// 点击input效果
function input_click(obj) {
  obj.parentNode.classList.add("active");
}
// input失焦效果
function input_blur(obj) {
  if (obj.value != "") {
    obj.parentNode.classList.add("active");
  } else {
    obj.parentNode.classList.remove("active");
  }
}
// 点击标题切换
function change_content(obj, index) {
  $(".exit-pop-custom-size-content .change-wrapper .change").removeClass(
    "active"
  );
  $(".exit-pop-custom-size-content .content-wrapper").removeClass("active");
  obj.classList.add("active");
  $(`.exit-pop-custom-size-content .content-wrapper-${index}`).addClass(
    "active"
  );
}
function change_content_find(index) {
  $(".exit-pop-custom-size-content .change-wrapper .change").eq(2).click();
  if ($(window).width() < 960) {
    $(".mb_sizetitle").removeClass("active");
    $(".exit-pop-custom-size-content .content-wrapper").css("display", "none");
    $(".size03-title.mb_sizetitle").click();
  }
}
function change_content_mb(obj, index) {
  if (obj.classList.contains("active")) {
    obj.classList.remove("active");
  } else {
    obj.classList.add("active");
  }
  $(`.exit-pop-custom-size-content .content-wrapper-${index}`).slideToggle(500);
}
// 表1/表2点击切换cm和inch
function cm_inch_change(index, obj) {
  $(
    ".exit-pop-custom-size-content .content-wrapper .choice_wrap .measurement_toggle .unit_of_length_btn"
  ).removeClass("active");
  let data_cm = [96.5, 100.5, 106.5, 112.5, 118.5, 124.5];
  let data_cm_2 = [42, 43, 44.5, 46, 47.5, 49];
  let data_cm_center = [66.5, 68.8, 70.5, 72.5, 72.5, 72.5];
  let data_cm_sleeve = [58.5, 59.5, 61, 62.5, 62.5, 62.5];
  let data_inch = ['38"', '40"', '42"', '44"', '47"', '49"'];
  let data_inch_2 = ['17"', '17"', '18"', '18"', '19"', '19"'];
  let data_inch_center = ['26"', '27"', '28"', '29"', '29"', '29"'];
  let data_inch_sleeve = ['23"', '23"', '24"', '25"', '25"', '25"'];
  let element = $("#table-1-data .td-3");
  let element_2 = $("#table-2-data .td-3");
  let element_center = $("#table-2-data .td-4");
  let element_sleeve = $("#table-2-data .td-5");
  if (index == 1) {
    $(
      ".exit-pop-custom-size-content .content-wrapper .choice_wrap .measurement_toggle .unit_of_length_btn_1"
    ).addClass("active");
    for (let i = 0; i < element.length; i++) {
      element[i].textContent = data_cm[i];
      element_2[i].textContent = data_cm_2[i];
      element_center[i].textContent = data_cm_center[i];
      element_sleeve[i].textContent = data_cm_sleeve[i];
    }
  } else {
    $(
      ".exit-pop-custom-size-content .content-wrapper .choice_wrap .measurement_toggle .unit_of_length_btn_2"
    ).addClass("active");
    for (let i = 0; i < element.length; i++) {
      element[i].textContent = data_inch[i];
      element_2[i].textContent = data_inch_2[i];
      element_center[i].textContent = data_inch_center[i];
      element_sleeve[i].textContent = data_inch_sleeve[i];
    }
  }
}
// 渲染表1
var table_1_data = [
  { Us: "0-2", Size: "XS", Bust: 96.5 },
  { Us: "4-6", Size: "S", Bust: 100.5 },
  { Us: "8-10", Size: "M", Bust: 106.5 },
  { Us: "12-14", Size: "L", Bust: 112.5 },
  { Us: "16", Size: "XL", Bust: 118.5 },
  { Us: "18", Size: "XXL", Bust: 124.5 },
];
var table_1_Body = document.getElementById("table-1-data");

for (var i = 0; i < table_1_data.length; i++) {
  var row = document.createElement("tr");
  row.setAttribute("data-index", `${i}`);

  var usCell = document.createElement("td");
  usCell.className = `td-1`;
  usCell.setAttribute("data-index", `1`);
  usCell.textContent = table_1_data[i].Us;

  var sizeCell = document.createElement("td");
  sizeCell.className = `td-2`;
  sizeCell.setAttribute("data-index", `2`);
  sizeCell.textContent = table_1_data[i].Size;

  var bustCell = document.createElement("td");
  bustCell.className = `td-3 td-hover`;
  bustCell.setAttribute("data-index", `3`);
  bustCell.textContent = table_1_data[i].Bust;

  row.appendChild(usCell);
  row.appendChild(sizeCell);
  row.appendChild(bustCell);
  console.log(table_1_Body);

  table_1_Body.appendChild(row);
}
// 输入input查找是否有对应的尺寸
function input_size(obj) {
  var inputValue = obj.value;
  var bustValues = $(".ave-sizechart-table tbody tr td:nth-child(3)")
    .map(function () {
      return $(this).text();
    })
    .get();

  if (inputValue != "") {
    for (var i = 0; i < bustValues.length; i++) {
      let bustValues_split = bustValues[i].split('"')[0];
      if (inputValue == bustValues_split) {
        $("#current-size").removeClass("none-find");
        $(`#table-1-data tr .td-2`).eq(i).addClass("match_size");
        $(`#table-1-data tr .td-3`).eq(i).addClass("match_size_2");
        let size = $(`#table-1-data tr .td-2`).eq(i).text();
        $("#current-size").text(`${size}`);
        break;
      } else {
        $(`#table-1-data tr .td-2`).removeClass("match_size");
        $(`#table-1-data tr .td-3`).removeClass("match_size_2");
        $("#current-size").addClass("none-find");
        $("#current-size").html(
          `Could not find your size? <span onclick="change_content_find(3)">Request Size Customization</span> now`
        );
      }
    }
  } else {
    $("#current-size").html(``);
    $(`#table-1-data tr .td-2`).removeClass("match_size");
    $(`#table-1-data tr .td-3`).removeClass("match_size_2");
    $("#current-size").removeClass("none-find");
  }
}
// 渲染表2
var table_2_data = [
  {
    US: "0-2",
    SIZE: "XS",
    "SHOULDER WIDTH": 42,
    "CENTER BACK LENGTH": 66.5,
    "SLEEVE LENGTH": 58.5,
  },
  {
    US: "4-6",
    SIZE: "S",
    "SHOULDER WIDTH": 43,
    "CENTER BACK LENGTH": 68.5,
    "SLEEVE LENGTH": 59.5,
  },
  {
    US: "8-10",
    SIZE: "M",
    "SHOULDER WIDTH": 44.5,
    "CENTER BACK LENGTH": 70.5,
    "SLEEVE LENGTH": 61,
  },
  {
    US: "12-14",
    SIZE: "L",
    "SHOULDER WIDTH": 46,
    "CENTER BACK LENGTH": 72.5,
    "SLEEVE LENGTH": 62.5,
  },
  {
    US: "16",
    SIZE: "XL",
    "SHOULDER WIDTH": 47.5,
    "CENTER BACK LENGTH": 72.5,
    "SLEEVE LENGTH": 62.5,
  },
  {
    US: "18",
    SIZE: "XXL",
    "SHOULDER WIDTH": 49,
    "CENTER BACK LENGTH": 72.5,
    "SLEEVE LENGTH": 62.5,
  },
];
var table = document.getElementById("table-2-data");

for (var i = 0; i < table_2_data.length; i++) {
  var item = table_2_data[i];

  var row = document.createElement("tr");
  row.setAttribute("data-index", `${i}`);

  var usCell = document.createElement("td");
  usCell.className = "td-1";
  usCell.setAttribute("data-index", "1");
  usCell.textContent = item["US"];

  var sizeCell = document.createElement("td");
  sizeCell.className = "td-2";
  sizeCell.setAttribute("data-index", "2");
  sizeCell.textContent = item["SIZE"];

  var shoulderWidthCell = document.createElement("td");
  shoulderWidthCell.className = "td-3 td-hover";
  shoulderWidthCell.setAttribute("data-index", "3");
  shoulderWidthCell.textContent = item["SHOULDER WIDTH"];

  var centerBackLengthCell = document.createElement("td");
  centerBackLengthCell.className = "td-4 td-hover";
  centerBackLengthCell.setAttribute("data-index", "4");
  centerBackLengthCell.textContent = item["CENTER BACK LENGTH"];

  var sleeveLengthCell = document.createElement("td");
  sleeveLengthCell.className = "td-5 td-hover";
  sleeveLengthCell.setAttribute("data-index", "5");
  sleeveLengthCell.textContent = item["SLEEVE LENGTH"];

  row.appendChild(usCell);
  row.appendChild(sizeCell);
  row.appendChild(shoulderWidthCell);
  row.appendChild(centerBackLengthCell);
  row.appendChild(sleeveLengthCell);

  table.appendChild(row);
}
// 表单鼠标移入动效
$(".ave-sizechart-table tbody tr td.td-hover").hover(
  function () {
    let index = $(this).attr("data-index");
    let index_2 = $(this).parents("tr").attr("data-index");
    let td = $(this).parents("tbody").find(`.td-${index}`);
    $(this).siblings().addClass("hover-color");
    $(`.th-${index}`).addClass("hover-color");
    $(this).addClass("active");
    for (let i = 0; i < index_2; i++) {
      td.eq(i).addClass("hover-color");
    }
  },
  function () {
    $("th").removeClass("hover-color");
    $("td").removeClass("hover-color");
    $("td").removeClass("active");
  }
);
// save保存数据
function save_data() {
  var inputs = document.querySelectorAll(
    ".content-wrapper-3 .content .box .input_wrap input"
  );
  var objects_data = [];
  var allFilled = true;

  for (var i = 0; i < inputs.length; i++) {
    var inputValue = inputs[i].value;
    // 检查输入值是否包含除数字以外的内容或为空
    if (/[^0-9]/.test(inputValue) || inputValue.trim() === "") {
      // 添加 error 类到祖先元素 .box
      inputs[i].parentNode.parentNode.classList.add("error");
      allFilled = false;
    } else {
      // 如果输入值符合条件，则移除 error 类
      inputs[i].parentNode.parentNode.classList.remove("error");
    }
  }

  // 储存数据
  if (allFilled == true) {
    var names = document.querySelectorAll(
      ".content-wrapper-3 .content .box .input_wrap .name"
    );
    var spans = document.querySelectorAll(
      ".content-wrapper-3 .content .box .input_wrap span"
    );
    var name_1 = names[0].textContent.replace("*", "");
    var value_1 = inputs[0].value.replace(".", "");
    var spanValue_1 = spans[0].textContent;
    var value_2 = inputs[1].value.replace(".", "");
    var spanValue_2 = spans[1].textContent;
    var obj = {};
    obj[name_1] = `${value_1}${spanValue_1} ${value_2}${spanValue_2}`;
    objects_data.push(obj);
    for (var i = 2; i < inputs.length; i++) {
      var name = names[i - 1].textContent.replace("*", "");
      var value = inputs[i].value.replace(".", "");
      var spanValue = spans[i].textContent;
      var obj = {};
      obj[name] = `${value}${spanValue}`;
      objects_data.push(obj);
    }

    for (
      var i = 0;
      i <
      document.querySelectorAll(
        ".custom_size-wrapper .customsuccess ul li span"
      ).length;
      i++
    ) {
      var propertyName = Object.keys(objects_data[i])[0];
      var propertyValue = objects_data[i][propertyName];
      document.querySelectorAll(
        ".custom_size-wrapper .customsuccess ul li span"
      )[i].textContent = propertyValue;
    }
    $(".custom_size-wrapper .customsuccess").css("display", "block");
    $(".custom_size-wrapper .top .left .custom_input_box").addClass("active");
    $(".custom_size-wrapper .top .left img").css("display", "block");
    hide_custom_size_pop();

    // 插入form表单
    var propertyValues = "";
    for (var i = 0; i < objects_data.length; i++) {
      // 获取当前对象
      var propertyName = Object.keys(objects_data[i])[0];
      var propertyValue = objects_data[i][propertyName];
      propertyValues += `${propertyName}:${propertyValue} `;
    }
    // 创建一个新的 <input> 元素
    var inputElement = document.createElement("input");
    inputElement.setAttribute("id", "properties");
    inputElement.setAttribute("type", "hidden");
    inputElement.setAttribute("name", `properties[custom_size]`);
    inputElement.value = propertyValues;
    // 将 <input> 元素插入表单中
    document
      .querySelector(".m-product-form--wrapper")
      .appendChild(inputElement);
  }

  $(".product-info__variants-wrapper-custom-Size input[value='Yes']").click();
}
// 移除数据
function remove_data() {
  $(".custom_size-wrapper .customsuccess ul li span").textContent = "";
  $(".custom_size-wrapper .customsuccess").css("display", "none");
  $(".custom_size-wrapper .top .left .custom_input_box").removeClass("active");
  $(".custom_size-wrapper .top .left img").css("display", "none");
  var inputElement = document.getElementById("properties");
  var formElement = inputElement.parentNode;
  formElement.removeChild(inputElement);

  $(
    ".product-info__variants-wrapper-custom-Size input[value='No'],.product-info__variants-wrapper-custom-Size input[value='NO']"
  ).click();
}
